import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TeamJoinRoutingModule } from './team-join-routing.module';
import { TeamJoinComponent } from './team-join.component';

@NgModule({
  imports: [
    CommonModule,
    TeamJoinRoutingModule,
    TeamJoinComponent  
  ]
})
export class TeamJoinModule {}
